import React from 'react';

export default props => {
  console.log('wc props', props)
  return (
    <div className="newark__full-screen-image-container" style={{ backgroundImage: `url(${props.image})` }}>
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/Components/Theme/Newark/NewarkFullScreenImage.js